import type {TText} from "./index";

export const createEnumItems = (enums, name, asNumbers = false) => {
	let options = [];
	if (enums[name] && !enums[name]["isFetchingInfo"]) {
		const items = enums[name]["items"];
		for (let i in items) {
			if (items.hasOwnProperty(i)) {
				options.push({value: asNumbers ? 1 * items[i].value : items[i].value, label: items[i].label})
			}
		}
	}

	return options;
};

export const getEnumTitle = (enums, name, value) => {
	if (!value && value !== 0) {
		return value
	}
	value = value + ""; // for ===
	if (enums && enums[name] && enums[name]['items'] && enums[name]['items'].length) {
		for (let i = 0; i < enums[name]['items'].length; i++) {
			const e = enums[name]['items'][i];
			if (value === e.value) {
				return e.label;
			}
		}
	}
	return value
};

export const getKey = (name, scope) => {
	if (!scope || name === 'entities') {
		return name
	}
	return name
		+ (scope.entityId ? '-e' + scope.entityId : '');
};

export const DEFAULT_CONTRACT_LOCATION = 've Lhotkách';

export const AnimalKind = {
	DOG: "DOG",
	OTHER: "OTHER"
}

export const AnimalKindLabel = {
	DOG: "Pes",
	OTHER: "Jiný"
}

export const animalKindOptions = [
	{value: AnimalKind.DOG, label: AnimalKindLabel.DOG},
	{value: AnimalKind.OTHER, label: AnimalKindLabel.OTHER},
]

export const DOG_MIX_BREED_ID = 439;

export const IntakeType = {
	F: "F",
	P: "P",
	R: "R",
	M: "M",
	B: "B",
	A: "A",
	I: "I",
	H: "H"
}

export const IntakeTypeLabel = {
	F: "Nález",
	P: "Odložení chovatelem",
	R: "Vrácení chovatelem",
	M: "Příjem od úřadu",
	B: "Narození",
	A: "Nevyzvednutí",
	I: "Dědictví",
	H: "Hotel"
}

export const IntakePartyLabel = {
	F: "Nálezce",
	P: "Chovatel",
	R: "Chovatel",
	M: "Úřad",
	// B: "Narození",
	A: "Zákazník",
	I: "Odkazník",
	H: "Zákazník"
}

export const ExitType = {
	RE: "RE",
	AN: "AN",
	AS: "AS",
	AT: "AT",
	AO: "AO",
	DE: "DE",
	ES: "ES",
	TH: "TH"
}

export const ExitTypeLabel = {
	RE: "Vrácení původnímu",
	AN: "Výdej novému",
	AS: "Výdej náhradnímu",
	AT: "Výdej dočasnému",
	AO: "Výdej organizaci",
	DE: "Smrt",
	ES: "Únik",
	TH: "Krádež"
}

export const ExitPartyLabel = {
	RE: "Chovatel",
	AN: "Chovatel",
	AS: "Chovatel",
	AO: "Organizace",
}

export const EventType = {
	CH: "CH",
	VA: "VA",
	PE: "PE",
	PI: "PI",
	CA: "CA",
	OT: "OT"
}

export const EventTypeLabel = {
	CH: "Čipování",
	VA: "Očkování",
	PE: "Ektopar.",
	PI: "Endopar.",
	CA: "Kastrace",
	OT: "Ostatní"
}

export const ExamType = {
	INT: "INT",
	VET: "VET"
}

export const ExamTypeLabel = {
	INT: "Interní",
	VET: "Veterinární"
}

export const TreatmentType = {
	OT: "OT",
	SHORT: "SHORT",
	CONT: "CONT"
}

export const TreatmentTypeLabel = {
	OT: "Jednorázově",
	SHORT: "Krátkodobě",
	CONT: "Dlouhodobě"
}

export const SizeType = {
	PP: "Štěně",
	XS: "Miniaturní",
	SM: "Malý",
	MD: "Střední",
	LG: "Velký",
	XL: "Obří"
}

export const PartyVariant = {
	INTAKE_MUNI: 'INTAKE_MUNI',
	INTAKE_PARTY: 'INTAKE_PARTY',
	ALT_PARTY: 'ALT_PARTY',
	EXIT_ORG: 'EXIT_ORG',
	EXIT_PARTY: 'EXIT_PARTY',
	WALKER: 'WALKER'
}

export const DogVariant = {
	DOG: 'DOG',
	MOTHER: 'MOTHER'
}

export const PartyType = {
	FO: "FO",
	PO: "PO"
}

export const PartyStatus = {
	ACTIVE: 'ACTIVE',
	DELETED: 'DELETED'
}

export const PartyRole = {
	WALKER: 'WALKER', // 1
	LEGAL: 'LEGAL', // 2
	MUNICIPALITY: 'MUNICIPALITY' // 4
}

export const PartyText: TText = {};
PartyText[PartyVariant.INTAKE_MUNI] = {
	tag: 'Obec',
	emptyText: 'Vyberte umisťující obec',
	search: 'Zadejte název',
	edit: 'Upravit obec',
	new: 'Nová obec',
	titleExisting: 'Úprava obce',
	titleNew: 'Založení obce',
	saveNew: 'Založit obec'
};
PartyText[PartyVariant.INTAKE_PARTY] = {
	tag: 'Osoba',
	emptyText: 'Vyberte',
	search: 'Zadejte jméno',
	edit: 'Upravit osobu',
	new: 'Nová osoba',
	titleExisting: 'Úprava osoby',
	titleNew: 'Založení osoby',
	saveNew: 'Založit osobu'
};
PartyText[PartyVariant.ALT_PARTY] = {
	tag: 'Osoba',
	emptyText: 'Vyberte',
	search: 'Zadejte jméno',
	edit: 'Upravit osobu',
	new: 'Nová osoba',
	titleExisting: 'Úprava osoby',
	titleNew: 'Založení pověřené osoby',
	saveNew: 'Založit osobu'
};
PartyText[PartyVariant.EXIT_ORG] = {
	tag: 'Organizace',
	emptyText: 'Vyberte organizaci',
	search: 'Zadejte název',
	edit: 'Upravit organizaci',
	new: 'Nová organizace',
	titleExisting: 'Úprava organizace',
	titleNew: 'Založení organizace',
	saveNew: 'Založit organizaci'
};
PartyText[PartyVariant.EXIT_PARTY] = {
	tag: 'Osoba',
	emptyText: 'Vyberte',
	search: 'Zadejte jméno',
	edit: 'Upravit osobu',
	new: 'Nová osoba',
	titleExisting: 'Úprava osoby',
	titleNew: 'Založení osoby',
	saveNew: 'Založit osobu'
};
PartyText[PartyVariant.WALKER] = {
	tag: 'Venčitel',
	emptyText: 'Vyberte venčitele',
	search: 'Zadejte jméno',
	edit: 'Upravit venčitele',
	new: 'Nový venčitel',
	titleExisting: 'Úprava venčitele',
	titleNew: 'Založení venčitele',
	saveNew: 'Založit venčitele'
};

export const newsletterOptions = [
	{'value': true, 'label': 'Ano'},
	{'value': false, 'label': 'Ne'}
];

export const partyStatusOptions = [
	{value: PartyStatus.ACTIVE, label: 'Aktivní'},
	{value: PartyStatus.DELETED, label: 'Smazaný'}
]

export const SexType = {
	M: "M",
	F: "F"
}

export const sexOptions = [
	{value: SexType.M, label: "♂"},
	{value: SexType.F, label: "♀"},
];

export const CastrationStatus = {
	YES: 'YES',
	NO: 'NO',
	UNKNOWN: 'UNKNOWN'
}

export const CastrationStatusLabel = {
	YES: 'Ano',
	NO: 'Ne',
	UNKNOWN: 'Nezjištěno'
}

export const AllergyStatus = {
	YES: 'YES',
	NO: 'NO',
	UNKNOWN: 'UNKNOWN'
}

export const AllergyStatusLabel = {
	YES: 'Ano',
	NO: 'Ne',
	UNKNOWN: 'Nezjištěno'
}

export const yesNoOptions = [
	{value: true, label: "Ano"},
	{value: false, label: "Ne"},
];

export const captureOptions = [
	{value: 'WO', label: 'bez použití odchytových pomůcek'},
	{value: 'WI', label: 's použitím odchytových pomůcek'},
	{value: 'SE', label: 'sedace'},
	{value: 'CO', label: 'kombinace'},
	{value: 'OT', label: 'jiné'},
]

export const WeightUnit = {
	G: 'G',
	KG: 'KG'
}

export const WeightUnitLabel = {
	G: 'g',
	KG: 'kg'
}

export const BaseStatus = {
	ACTIVE: 'ACTIVE',
	DELETED: 'DELETED'
}

export const ExpireStatus = {
	PENDING: 'PENDING',
	APPLIED: 'APPLIED',
	EXPIRED: 'EXPIRED'
}

export const ExpireStatusLabel = {
	PENDING: 'Čeká',
	APPLIED: 'Obnoveno',
	EXPIRED: 'Propadlo'
}



// WEBPACK FOOTER //
// ./src/utils/enums.js